<template>
  <div class="agreement-modal-overlay" v-if="visible">
    <div class="agreement-modal">
      <div class="agreement-modal-header">
        <h2 class="agreement-title">{{ title || agreementData.title }}</h2>
        <span class="close-btn" @click="handleCancel">&times;</span>
      </div>
      <div class="agreement-modal-content" @scroll="handleScroll" ref="contentRef">
        <pre class="agreement-content" v-html="content || agreementData.content"></pre>
      </div>
      <div class="agreement-hint" v-if="!canConfirm">
       请滚动到页面底部以启用确认按钮
     </div>
      <div class="agreement-modal-footer">
        <button 
          class="cancel-btn" 
          @click="handleCancel">取消
        </button>
        <button 
          class="confirm-btn" 
          @click="handleConfirm"
          :disabled="!canConfirm"
        >
          确认并同意
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watch } from 'vue';
import { getCurrentInstance } from 'vue';

export default {
  name: "AgreementModal",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default: 1
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    }
  },
  emits: ['confirm', 'cancel'],
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    const canConfirm = ref(false);
    const contentRef = ref(null);
    const agreementData = ref({
      title: '',
      content: ''
    });

    // 根据类型获取协议代码
    const getAgreementCode = (type) => {
        console.log('传入的模态框type值:', type);
      switch(type) {
        case 1:
          return 'register_agreement';
        case 2:
          return 'privacy_policy';
        case 5:
          return 'buy_agreement';
        default:
          return 'register_agreement';
      }
    };

    // 检查是否滚动到底部
   const handleScroll = () => {
     if (contentRef.value) {
       const { scrollTop, scrollHeight, clientHeight } = contentRef.value;
       // 当滚动到底部附近时启用确认按钮
       if (scrollTop + clientHeight >= scrollHeight - 10) {
         canConfirm.value = true;
       }
     }
   };

    // 获取协议内容
    const fetchAgreementContent = () => {
      const agreementCode = getAgreementCode(props.type);
      proxy.$get('v3/system/front/agreement/detail', { agreementCode }).then(res => {
        if (res.state == 200) {
          agreementData.value.title = res.data.title;
          agreementData.value.content = proxy.$quillEscapeToHtml(res.data.content);
          // 重置确认状态
          canConfirm.value = false;
        }
      });
    };

    const handleConfirm = () => {
      if (canConfirm.value) {
        emit('confirm');
      }
    };

    const handleCancel = () => {
       emit('cancel');
    };

   watch(() => props.visible, (newVal, oldVal) => {
    console.log('模态框visible变化:', oldVal, '->', newVal);
    if (newVal) {
        // 改进判断逻辑：只有当title和content都为空时才获取数据
        if (!props.title && !props.content) {
            fetchAgreementContent();
        }
        // 初始化确认状态
        canConfirm.value = false;
            
        } else {
          // 重置确认状态
          canConfirm.value = false;
        }
    }, { immediate: true });

    watch(() => props.type, (newVal, oldVal) => {

    if (props.visible && newVal !== oldVal) {
        // 当类型改变且模态框可见时，重新获取内容
        if (!props.title && !props.content) {
        fetchAgreementContent();
        }
    }
    });

    return {
      canConfirm,
       contentRef,
       handleScroll,
      agreementData,
      handleConfirm,
      handleCancel
    };
  }
};
</script>

<style lang="scss" scoped>
/* 样式保持不变 */
.agreement-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.agreement-modal {
  background: #fff;
  border-radius: 4px;
  width: 950px;
  max-height: 82vh;
  display: flex;
  flex-direction: column;
}

.agreement-modal-header {
  padding: 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  .agreement-title {
    margin: 0;
    font-size: 18px;
    color: #333;
  }
  
  .close-btn {
    font-size: 24px;
    cursor: pointer;
    color: #999;
    
    &:hover {
      color: #333;
    }
  }
}

.agreement-modal-content {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  
  .agreement-content {
    font-size: 14px;
    line-height: 1.6;
    white-space: pre-wrap;
    word-break: break-all;
    margin: 0;
  }
}

.agreement-hint {
     text-align: center;
     padding: 8px;
     background-color: #f0f8ff;
     color: #666;
     font-size: 12px;
   }


.agreement-modal-footer {
  padding: 20px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  
  button {
    padding: 8px 20px;
    border: 1px solid #ddd;
    border-radius: 4px;
    cursor: pointer;
    
    &.cancel-btn {
      background: #fff;
      color: #666;
      
      &:hover:not(:disabled) {
        background: #f5f5f5;
      }
    }
    
    &.confirm-btn {
      background: #409eff;
      color: #fff;
      border-color: #409eff;
      
      &:hover:not(:disabled) {
        background: #66b1ff;
      }
    }
    
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
}
</style>